import React from 'react';
import { ArrowRight, Play, GraduationCap } from 'lucide-react';
import { heroContent } from '../mock';

const Hero = () => {
  const h = heroContent;
  return (
    <section
      id="top"
      className="relative bg-[#FAF6EC] pt-28 md:pt-32 pb-24 overflow-hidden"
    >
      {/* Decorative dots grid */}
      <div className="absolute top-24 left-8 grid grid-cols-4 gap-1 opacity-30">
        {Array.from({ length: 16 }).map((_, i) => (
          <span key={i} className="w-1 h-1 rounded-full bg-[#1E3A5F]" />
        ))}
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left */}
        <div className="relative">
          <p className="text-[13px] font-medium text-[#1E3A5F]/70 mb-5">
            {h.eyebrow}
          </p>
          <h1 className="font-serif text-[56px] md:text-[86px] leading-[0.95] font-bold tracking-tight">
            {h.titleLines.map((line, i) => (
              <span
                key={i}
                className={`block ${line.color} ${line.italic ? 'italic' : ''}`}
              >
                {line.text}
              </span>
            ))}
          </h1>

          <p className="mt-6 text-[15px] text-[#1E3A5F]/75 max-w-md leading-relaxed">
            {h.description}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#contacto"
              className="inline-flex items-center gap-2 bg-[#E8B84A] hover:bg-[#DDA932] text-[#1E3A5F] text-[14px] font-semibold px-6 py-3.5 rounded-full transition-colors"
            >
              {h.primaryCta}
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#cursos"
              className="inline-flex items-center gap-2 text-[14px] font-medium text-[#1E3A5F] hover:text-[#9B2C3B] transition-colors"
            >
              {h.secondaryCta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>

          <div className="mt-10 flex items-center gap-4">
            <div className="flex -space-x-2">
              <span className="h-8 w-8 rounded-full bg-[#9B2C3B] border-2 border-[#FAF6EC]" />
              <span className="h-8 w-8 rounded-full bg-[#E8B84A] border-2 border-[#FAF6EC]" />
              <span className="h-8 w-8 rounded-full bg-[#5B84A6] border-2 border-[#FAF6EC]" />
              <span className="h-8 w-8 rounded-full bg-[#1E3A5F] border-2 border-[#FAF6EC]" />
            </div>
            <div>
              <div className="text-[13px] font-semibold text-[#1E3A5F]">
                {h.communityLabel}
              </div>
              <div className="text-[11px] text-[#1E3A5F]/60">{h.communitySub}</div>
            </div>
          </div>
        </div>

        {/* Right - Card */}
        <div className="relative">
          <div className="absolute -top-6 -right-2 md:right-6 z-10 rotate-6">
            <div className="bg-[#E8B84A] text-[#1E3A5F] text-[11px] font-bold tracking-widest px-4 py-2 rounded-full shadow-md">
              {h.badge}
            </div>
          </div>

          <div className="relative bg-[#1E3A5F] rounded-3xl aspect-[5/4] shadow-xl overflow-hidden group">
            <button className="absolute inset-0 flex items-center justify-center">
              <span className="h-16 w-16 rounded-full bg-white/10 backdrop-blur border border-white/20 flex items-center justify-center group-hover:scale-110 transition-transform">
                <Play className="h-6 w-6 text-white ml-1" fill="currentColor" />
              </span>
            </button>

            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between bg-[#15294A]/85 backdrop-blur px-4 py-3 rounded-2xl border border-white/10">
              <div>
                <div className="text-[10px] font-semibold text-[#E8B84A] tracking-widest">
                  {h.cardTitle}
                </div>
                <div className="text-[13px] font-medium text-white">
                  {h.cardSubtitle}
                </div>
              </div>
              <button className="h-8 w-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                <ArrowRight className="h-4 w-4 text-white" />
              </button>
            </div>
          </div>

          {/* Chip - light blue */}
          <div className="absolute -bottom-6 left-6 bg-[#5B84A6] text-white px-4 py-2.5 rounded-2xl shadow-md rotate-[-3deg] flex items-center gap-2">
            <GraduationCap className="h-5 w-5" />
            <div>
              <div className="text-[12px] font-bold leading-tight">{h.chip}</div>
              <div className="text-[10px] leading-tight opacity-90">{h.chipSub}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
